import React, {PureComponent} from "react";
import { Helmet } from "react-helmet";
import "./Contact.css";
import ContactForm from "./components/ContactForm/ContactForm";
import Header from "../../components/Header/Header";
import headerImg from "../../assets/images/backgrounds/Kontaktgr.jpg";

class Contact extends PureComponent {
  componentDidMount() {
    if(this.props.match && this.props.match.params && this.props.match.params.scroll) {
      const offset = window.innerWidth > 768 ? (window.innerHeight *0.95 ) : (window.innerHeight * 0.6);
      window.scrollTo(0, offset);
    }
  }
  render(){
    return (
      <div>
        <Helmet>
          <title>Corviva | Kontakt</title>
        </Helmet>
        <Header
          big_header="kontakt"
          bgImage={headerImg}
          strength={200}
          page="contact"
          offset={window.innerWidth < 768 ? -80 : -60}
        />
        <div id="contact" name="contact" className="contact container-fluid">
          <div className="row">
            <div className="col-md-8 offset-md-2 text-center">
              <h3>Kontakt</h3>
              <p>
                Vill du veta mer om våra tjänster, eller boka en demo?
                Oavsett ärende är du varmt välkommen att kontakta oss!
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 offset-md-4 offset-1 col-10  text-center">
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 offset-md-2 text-center call">
              <p>
                Ring Victor Östling <br />
                <a href="tel:+46702225894">+46 (0) 70-222 58 94 </a> <br />
                <br />
                <i>
                  ...eller använd kontaktformuläret nedan så hör vi av oss!
                </i>
                <br />
              </p>
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    );
  }
};

export default Contact;



// WEBPACK FOOTER //
// ./src/routes/Contact/Contact.jsx